import React from 'react';

const Compliance = () => (
  <div className="max-w-3xl mx-auto bg-white rounded-xl shadow p-8 my-8">
    <h1 className="text-3xl font-bold mb-6 text-blue-700">Compliance & Legal Information</h1>

    <section className="mb-6">
      <h2 className="text-xl font-semibold mb-2">Privacy Policy</h2>
      <p className="text-gray-700">We respect your privacy. Your data is collected, stored, and processed securely. We do not sell your personal information to third parties. For more details, see our full Privacy Policy.</p>
    </section>

    <section className="mb-6">
      <h2 className="text-xl font-semibold mb-2">Terms of Service</h2>
      <p className="text-gray-700">By using LinkCab, you agree to our Terms of Service. Please use our platform responsibly and in accordance with all applicable laws and regulations.</p>
    </section>

    <section className="mb-6">
      <h2 className="text-xl font-semibold mb-2">Cookie Policy</h2>
      <p className="text-gray-700">We use cookies to enhance your experience. You can manage your cookie preferences in your browser settings. For more information, see our Cookie Policy.</p>
    </section>

    <section className="mb-6">
      <h2 className="text-xl font-semibold mb-2">Accessibility Statement</h2>
      <p className="text-gray-700">We are committed to making our website accessible to everyone, including people with disabilities. If you encounter any accessibility issues, please contact us.</p>
    </section>

    <section className="mb-6">
      <h2 className="text-xl font-semibold mb-2">GDPR & CCPA Compliance</h2>
      <p className="text-gray-700">We comply with the General Data Protection Regulation (GDPR) and California Consumer Privacy Act (CCPA). You have the right to access, correct, or delete your personal data. Contact us for any data requests.</p>
    </section>

    <section className="mb-6">
      <h2 className="text-xl font-semibold mb-2">Security Practices</h2>
      <p className="text-gray-700">We use industry-standard security measures to protect your data and transactions. Our team regularly reviews and updates our security protocols.</p>
    </section>

    <section className="mb-6">
      <h2 className="text-xl font-semibold mb-2">Legal Disclaimers</h2>
      <p className="text-gray-700">All information provided on this platform is for informational purposes only. We are not liable for any damages resulting from the use of our service. Please consult our full legal disclaimer for more details.</p>
    </section>

    <section className="mb-2">
      <h2 className="text-xl font-semibold mb-2">Contact Information</h2>
      <p className="text-gray-700">For compliance, privacy, or legal inquiries, contact us at <a href="mailto:yugayatraretail.in" className="text-blue-600 underline">yugayatraretail.in</a> or call <a href="tel:8320743025" className="text-blue-600 underline">8320743025</a>.</p>
    </section>
  </div>
);

export default Compliance; 